import * as moment from 'moment';

export default class DateTimeUtil {

  static dateTimeFormat = 'YYYY-MM-DD HH:mm';
  static dateFormat = 'YYYY-MM-DD HH:mm';


  static dateSetter(date:string, offset?: number) {
    if(date == null) return;

    let setDate = null;
    let momentValue = moment(date);
    if (offset == null || offset == undefined) {
      let localOffset: number = moment.parseZone(date).utcOffset();
      setDate = momentValue.utc().add(localOffset, 'minutes').format('YYYY-MM-DD');      
    } else {
      setDate = momentValue.utc().add(offset, 'hours').format('YYYY-MM-DD');
    }
    
    return setDate;    
  }

  static timeSetter(time:string, offset?: number) {
    if(time == null) return;
  
    let setTime = null;
    let momentValue = moment(time);
    if (offset == null || offset == undefined) {
      let localOffset: number = moment.parseZone(time).utcOffset();
      setTime = momentValue.utc().add(localOffset, 'minutes').format('HH:mm');
    } else {
      setTime = momentValue.utc().add(offset, 'hours').format('HH:mm');
    }

    return setTime;
  }

  static dateTimeSetter(datetime:string, offset?: number, format?:string) {
    if(datetime == null) return;

    let timepre = null;
    if(format) timepre = moment(datetime, format);
    else timepre = datetime;

    let setDate = null;
    let momentValue = moment(timepre);

    if (offset == null || offset == undefined) {
      let localOffset: number = moment.parseZone(timepre).utcOffset();
      setDate = momentValue.utc().add(localOffset, 'minutes').format('YYYY-MM-DD HH:mm');
    } else {
      setDate = momentValue.utc().add(offset, 'hours').format('YYYY-MM-DD HH:mm');
    }
    
    return setDate;
  }

  static dateTimeShortSetter(datetime:string, offset?: number) {
    if(datetime == null) return;

    let setDate = null;
    let momentValue = moment(datetime);

    if (offset == null || offset == undefined) {
      let localOffset: number = moment.parseZone(datetime).utcOffset();
      setDate = momentValue.utc().add(localOffset, 'minutes').format('YY/MM/DD HH:mm');
    } else {
      setDate = momentValue.utc().add(offset, 'hours').format('YY/MM/DD HH:mm');
    }

    return setDate;
  }

  static dateTimeShortSetterWithFormat(datetime:string, format:string) {
    if(datetime == null) return;

    let setDate = null;
    if(format) setDate = moment(datetime, format).format('YY/MM/DD HH:mm');
    
    return setDate;
  }

  static dateTimeToString(datetime:string, offset?: number, format?:string) {
    if(datetime == null) return;

    let timePre = null
    if(format) timePre = moment(datetime, format);
    else timePre = moment(datetime);

    let setDate = null;
    let momentValue = moment(datetime);

    if (offset == null || offset == undefined) {
      let localOffset: number = moment.parseZone(datetime).utcOffset();
      setDate = momentValue.utc().add(localOffset, 'minutes').format('YYYYMMDDHHmmss').toString();
    } else {
      setDate = momentValue.utc().add(offset, 'hours').format('YYYYMMDDHHmmss').toString();
    }
    return setDate;
  }

  static dateTimeDiff(datetime:string, offset?: number, format?:string) {
    if(datetime == null) return;
    let today = moment();
    
    let timePre = null
    if(format) timePre = moment(datetime, format);
    else timePre = moment(datetime);

    let setDate = null;
    let momentValue = moment(timePre);

    if (offset == null || offset == undefined) {
      let localOffset: number = moment.parseZone(timePre).utcOffset();
      setDate = momentValue.utc().add(localOffset, 'minutes');
    } else {
      setDate = momentValue.utc().add(offset, 'hours');
    }
    
    let diffTime = today.diff(timePre, 'milliseconds');

    return diffTime;
  }

  static getProgress(vessel) {
    let start = null;
    let end = null;
    let now = moment().utc(); 
    
    if(vessel.atd) start = moment(vessel.atd);
    else if(vessel.etd) start = moment(vessel.etd);
    else start = null;
    
    if(vessel.ata) end = moment(vessel.ata);
    else if(vessel.eta) end = moment(vessel.eta);
    else end = null;

    if(!start || !end) return 0;
    else {
      let progress = null;
      let fromToDuration = end.diff(start, 'milliseconds');
      let fromToNowDuration = now.diff(start, 'milliseconds');
      if(fromToNowDuration > fromToDuration) {
        progress = 100;
        return progress;
      }
      progress = Math.round((fromToNowDuration/fromToDuration) * 100);
      return progress;
    }
  }

  static getShipmentProgress(vesselInfo) {
    let vessel = vesselInfo;

    let start = null;
    let end = null;
    let now = moment().utc(); 
    
    if(vessel.atd) start = moment(vessel.atd);
    else if(vessel.etd) start = moment(vessel.etd);
    else start = null;
    
    if(vessel.ata) end = moment(vessel.ata);
    else if(vessel.eta) end = moment(vessel.eta);
    else end = null;
    

    if(!start || !end) {
      return 0;
    } else {
      let progress = null;
      let fromToDuration = end.diff(start, 'milliseconds');
      let fromToNowDuration = now.diff(start, 'milliseconds');
      if(fromToNowDuration < 0) {
        progress = 0;
        return progress;
      }
      if(fromToNowDuration > fromToDuration) {
        progress = 100;
        return progress;
      }
      progress = Math.round((fromToNowDuration/fromToDuration) * 100);
      return progress;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/utils/datatime.ts